function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import checkdouble from '../../public/checkdouble.svg';
import { Box, IconButton, Menu, Typography, Switch, Divider, Tooltip, Fab } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { constants } from '../constants';
import { NotificationAPI } from '../apis/NotificationAPI';
import AlertStateIcon from '../../public/AlertStateIcon.svg';
import { notificationApiError } from '@/utils/notificationApiError';
import { getNotificationIcon, groupNotifications, getTimeAgo, NOTIFICATION_POLL_INTERVAL_MS, NOTIFICATION_TITLES, getFormattedNotificationMessage } from '../utils/notificationUtils';
import { getUserFromCookie } from '@/utils/utilities';
import { ConfigContext } from './ConfigContext';
import { usePlatformHost } from '../hooks/usePlatformHost';
import Sound from './Sound/Sound';
import { PermissionGate } from './PermissionGate';
import { RBAC_ACTIONS } from '@/utils/permissionGateConfig';
import { useSurveyNotification } from '@/hooks/useSurveyNotification';
var groupLabels = {
    lastWeek: constants.LAST_WEEK,
    lastMonth: constants.LAST_MONTH,
    threeMonthsAgo: constants.THREE_MONTHS_AGO,
    oneYearAgo: constants.ONE_YEAR_AGO,
    older: constants.OLDER
};
var NotificationItem = function NotificationItem(_ref) {
    var _configState$settings, _notification$title, _notification$title2, _notification$meta, _notification$title3;
    var notification = _ref.notification;
    var theme = useTheme();
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    var buttonColor = (configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color) || theme.palette.primary.main;
    var textRef = useRef(null);
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isOverflowing = _useState2[0], setIsOverflowing = _useState2[1];
    // Get formatted message (handles upgrade/maintenance date formatting)
    var displayMessage = getFormattedNotificationMessage((_notification$title = notification === null || notification === void 0 ? void 0 : notification.title) !== null && _notification$title !== void 0 ? _notification$title : '', notification === null || notification === void 0 ? void 0 : notification.message, notification === null || notification === void 0 ? void 0 : notification.scheduled, notification === null || notification === void 0 ? void 0 : notification.expires);
    // Check if this is a survey notification
    var isSurveyNotification = ((_notification$title2 = notification === null || notification === void 0 ? void 0 : notification.title) !== null && _notification$title2 !== void 0 ? _notification$title2 : '').toLowerCase().includes(NOTIFICATION_TITLES.SURVEY_AVAILABLE.toLowerCase());
    // Handle Get Started button click
    var handleGetStartedClick = function handleGetStartedClick() {
        if (notification !== null && notification !== void 0 && notification.url) {
            window.open(notification.url, '_blank', 'noopener,noreferrer');
        }
    };
    useEffect(function () {
        var element = textRef.current;
        if (element) {
            setIsOverflowing(element.scrollHeight > element.clientHeight);
        }
    }, [displayMessage]);
    return /*#__PURE__*/ React.createElement(Box, {
        key: notification.id,
        sx: _objectSpread({
            display: 'flex',
            alignItems: 'flex-start',
            background: notification.viewedDateTime ? theme.palette.background["default"] : theme.palette.background.paper,
            border: notification.viewedDateTime ? 'none' : "1px solid ".concat(theme.palette.background.paper),
            borderRadius: 3,
            borderBottom: notification.viewedDateTime ? "1px solid ".concat(theme.palette.divider) : 'none',
            pl: 2,
            pt: 2.5,
            pb: 2.5,
            pr: 2.5,
            mb: 0.5,
            position: 'relative'
        }, !notification.viewedDateTime && {
            '&:hover': {
                borderRadius: '12px',
                border: "1px solid ".concat(theme.palette.grey[400]),
                background: theme.palette.background.paper
            }
        })
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            position: 'absolute',
            top: 20,
            right: 20,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        sx: {
            color: theme.palette.text.secondary,
            fontSize: 12,
            fontWeight: 400,
            whiteSpace: 'nowrap'
        },
        "data-testid": "typography-caption"
    }, getTimeAgo((_notification$meta = notification.meta) === null || _notification$meta === void 0 ? void 0 : _notification$meta.created)), !notification.viewedDateTime && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: theme.palette.error.main
        }
    })), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mr: 2,
            flexShrink: 0
        }
    }, getNotificationIcon((_notification$title3 = notification.title) !== null && _notification$title3 !== void 0 ? _notification$title3 : '', '#000000')), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        sx: {
            fontWeight: 600,
            fontSize: 16,
            color: theme.palette.text.primary,
            pr: 8
        },
        "data-testid": "typography-subtitle2"
    }, notification.title), /*#__PURE__*/ React.createElement(Tooltip, {
        title: isOverflowing ? displayMessage : '',
        arrow: true,
        placement: "bottom",
        disableHoverListener: !isOverflowing,
        slotProps: {
            tooltip: {
                sx: {
                    maxWidth: 300,
                    marginRight: '16px',
                    backgroundColor: '#000000',
                    color: '#ffffff',
                    fontSize: '14px',
                    fontWeight: 300,
                    lineHeight: '16px',
                    padding: '8px 12px',
                    borderRadius: '4px'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        ref: textRef,
        variant: "body2",
        sx: {
            color: theme.palette.text.secondary,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.4,
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        },
        "data-testid": "typography-body2"
    }, displayMessage)), isSurveyNotification && notification.url && /*#__PURE__*/ React.createElement(Typography, {
        component: "span",
        onClick: handleGetStartedClick,
        "data-testid": "get-started-button",
        sx: {
            mt: 0.5,
            color: buttonColor || theme.palette.primary.main,
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '152%',
            letterSpacing: '0.17px',
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }, constants.get_started_button)));
};
// Helper: Get badge styles
var getBadgeStyles = function getBadgeStyles(theme) {
    return {
        '& .MuiBadge-badge': {
            minWidth: 18,
            width: 18,
            height: 18,
            borderRadius: '50%',
            fontSize: 10,
            fontWeight: 600,
            border: 'none',
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0
        }
    };
};
var NotificationModal = function NotificationModal() {
    var _configState$settings3, _configState$settings4, _configState$settings5, _configState$settings6, _configState$settings7, _configState$settings8;
    var theme = useTheme();
    var _useContext2 = useContext(ConfigContext), configState = _useContext2.configState;
    var getPlatformHost = usePlatformHost();
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), platformHost = _useState4[0], setPlatformHost = _useState4[1];
    useEffect(function () {
        getPlatformHost().then(setPlatformHost);
    }, [getPlatformHost]);
    // Hook for rating notification
    var _useSurveyNotificatio = useSurveyNotification(), shouldShowSurveyNotification = _useSurveyNotificatio.shouldShowSurveyNotification, isSurveyLoading = _useSurveyNotificatio.isSurveyLoading;
    // State for rating notification
    var _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), ratingSubmitted = _useState6[0], setRatingSubmitted = _useState6[1];
    var _useState7 = useState(0), _useState8 = _slicedToArray(_useState7, 2), selectedRating = _useState8[0], setSelectedRating = _useState8[1];
    var _useState9 = useState(0), _useState0 = _slicedToArray(_useState9, 2), hoveredRating = _useState0[0], setHoveredRating = _useState0[1];
    var _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), isFadingRating = _useState10[0], setIsFadingRating = _useState10[1];
    var _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), isRatingDismissed = _useState12[0], setIsRatingDismissed = _useState12[1];
    // Determine bell icon color based on header background color
    var getBellIconColor = function getBellIconColor() {
        var _configState$settings2;
        var headerBgColor = (configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.header_background_color) || '#fff';
        var isWhiteBackground = headerBgColor.toUpperCase() === '#FFFFFF' || headerBgColor.toUpperCase() === '#FFF';
        return isWhiteBackground ? '#000000' : '#FFFFFF';
    };
    var _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), anchorEl = _useState14[0], setAnchorEl = _useState14[1];
    var open = Boolean(anchorEl);
    var _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), onlyUnread = _useState16[0], setOnlyUnread = _useState16[1];
    var _useState17 = useState(0), _useState18 = _slicedToArray(_useState17, 2), unreadCount = _useState18[0], setUnreadCount = _useState18[1];
    var _useState19 = useState([]), _useState20 = _slicedToArray(_useState19, 2), notifications = _useState20[0], setNotifications = _useState20[1];
    var _useState21 = useState('50%'), _useState22 = _slicedToArray(_useState21, 2), tipPosition = _useState22[0], setTipPosition = _useState22[1];
    var _useState23 = useState(''), _useState24 = _slicedToArray(_useState23, 2), userId = _useState24[0], setUserId = _useState24[1];
    var _useState25 = useState(null), _useState26 = _slicedToArray(_useState25, 2), error = _useState26[0], setError = _useState26[1];
    var _useState27 = useState(false), _useState28 = _slicedToArray(_useState27, 2), isLoadingMore = _useState28[0], setIsLoadingMore = _useState28[1];
    var _useState29 = useState(true), _useState30 = _slicedToArray(_useState29, 2), hasMore = _useState30[0], setHasMore = _useState30[1];
    var _useState31 = useState(0), _useState32 = _slicedToArray(_useState31, 2), offset = _useState32[0], setOffset = _useState32[1];
    var _useState33 = useState(false), _useState34 = _slicedToArray(_useState33, 2), showScrollTop = _useState34[0], setShowScrollTop = _useState34[1];
    var scrollContainerRef = useRef(null);
    var LIMIT = 10;
    var _useState35 = useState(false), _useState36 = _slicedToArray(_useState35, 2), play = _useState36[0], setPlay = _useState36[1];
    // Set user ID and username on component mount
    useEffect(function () {
        var user = getUserFromCookie();
        setUserId(user.id);
    }, []);
    useEffect(function () {
        if (open) {
            globalThis.dispatchEvent(new Event('notificationModalOpen'));
        }
        else {
            globalThis.dispatchEvent(new Event('notificationModalClose'));
        }
    }, [open]);
    var calculateTipPosition = function calculateTipPosition() {
        if (!anchorEl)
            return;
        var badge = anchorEl.querySelector('.MuiBadge-root');
        var notificationIcon = anchorEl.querySelector('[data-testid="notifications-icon"]');
        var targetElement = badge || notificationIcon;
        if (!targetElement)
            return;
        var iconRect = targetElement.getBoundingClientRect();
        var menuPaper = document.querySelector('[data-testid="notification-menu"] .MuiPaper-root');
        if (!menuPaper)
            return;
        var menuRect = menuPaper.getBoundingClientRect();
        var iconCenterX = iconRect.left + iconRect.width / 2;
        var distanceFromMenuLeft = iconCenterX - menuRect.left;
        var percentageFromLeft = distanceFromMenuLeft / menuRect.width * 100;
        var clampedPercentage = Math.max(5, Math.min(95, percentageFromLeft));
        setTipPosition("".concat(clampedPercentage, "%"));
    };
    useEffect(function () {
        if (!open || !anchorEl)
            return;
        requestAnimationFrame(function () {
            setTimeout(calculateTipPosition, 150);
        });
    }, [open, anchorEl]);
    var handleBellClick = function handleBellClick(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function handleClose() {
        setAnchorEl(null);
    };
    var getErrorMessage = function getErrorMessage(err) {
        var _err$response, _err$message, _matchedPattern$;
        // Check for API error code first
        var errorCode = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.errorCode;
        if (errorCode && typeof errorCode === 'string' && errorCode in notificationApiError) {
            return notificationApiError[errorCode].message;
        }
        // Map error message patterns to error types
        var errorPatterns = {
            'Network Error': notificationApiError.NETWORK_ERROR.message,
            timeout: notificationApiError.TIMEOUT.message,
            '401': notificationApiError.UNAUTHORIZED.message,
            '403': notificationApiError.FORBIDDEN.message,
            '404': notificationApiError.NOT_FOUND.message,
            'rate limit': notificationApiError.RATE_LIMITED.message,
            CORS: notificationApiError.CORS_ERROR.message,
            'Service Unavailable': notificationApiError.SERVICE_UNAVAILABLE.message
        };
        // Find matching error pattern in message
        var errorMessage = (_err$message = err === null || err === void 0 ? void 0 : err.message) !== null && _err$message !== void 0 ? _err$message : '';
        var matchedPattern = Object.entries(errorPatterns).find(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 1), pattern = _ref3[0];
            return errorMessage.includes(pattern);
        });
        return (_matchedPattern$ = matchedPattern === null || matchedPattern === void 0 ? void 0 : matchedPattern[1]) !== null && _matchedPattern$ !== void 0 ? _matchedPattern$ : notificationApiError.SERVER_ERROR.message;
    };
    var mapNotificationEntry = function mapNotificationEntry(entry) {
        var _resource$resourceTyp, _resource$to, _resource$ccTo, _resource$bccTo, _resource$from, _resource$title, _resource$additionalI, _resource$messageType, _resource$message, _resource$channels, _resource$meta$versio, _resource$meta, _resource$meta$create, _resource$meta2, _resource$meta3, _resource$meta4, _resource$meta5, _resource$meta$isDele, _resource$meta6, _resource$meta7, _resource$meta8, _resource$meta9, _resource$meta0;
        var resource = entry.resource;
        return {
            resourceType: (_resource$resourceTyp = resource.resourceType) !== null && _resource$resourceTyp !== void 0 ? _resource$resourceTyp : 'Notification',
            id: resource === null || resource === void 0 ? void 0 : resource.id,
            to: (_resource$to = resource === null || resource === void 0 ? void 0 : resource.to) !== null && _resource$to !== void 0 ? _resource$to : [],
            ccTo: (_resource$ccTo = resource === null || resource === void 0 ? void 0 : resource.ccTo) !== null && _resource$ccTo !== void 0 ? _resource$ccTo : [],
            bccTo: (_resource$bccTo = resource === null || resource === void 0 ? void 0 : resource.bccTo) !== null && _resource$bccTo !== void 0 ? _resource$bccTo : [],
            from: (_resource$from = resource === null || resource === void 0 ? void 0 : resource.from) !== null && _resource$from !== void 0 ? _resource$from : {
                type: '',
                value: ''
            },
            title: (_resource$title = resource === null || resource === void 0 ? void 0 : resource.title) !== null && _resource$title !== void 0 ? _resource$title : constants.notification_default_title,
            subtitle: resource === null || resource === void 0 ? void 0 : resource.subtitle,
            scheduled: resource === null || resource === void 0 ? void 0 : resource.scheduled,
            expires: resource === null || resource === void 0 ? void 0 : resource.expires,
            additionalInformation: (_resource$additionalI = resource === null || resource === void 0 ? void 0 : resource.additionalInformation) !== null && _resource$additionalI !== void 0 ? _resource$additionalI : [],
            url: resource === null || resource === void 0 ? void 0 : resource.url,
            messageType: (_resource$messageType = resource === null || resource === void 0 ? void 0 : resource.messageType) !== null && _resource$messageType !== void 0 ? _resource$messageType : 'Text',
            message: (_resource$message = resource === null || resource === void 0 ? void 0 : resource.message) !== null && _resource$message !== void 0 ? _resource$message : '',
            channels: (_resource$channels = resource === null || resource === void 0 ? void 0 : resource.channels) !== null && _resource$channels !== void 0 ? _resource$channels : [],
            viewedDateTime: resource === null || resource === void 0 ? void 0 : resource.viewedDateTime,
            attachment: resource !== null && resource !== void 0 && resource.attachment ? {
                contentTransferEncoding: resource.attachment.contentTransferEncoding,
                content: resource.attachment.content,
                contentDescription: resource.attachment.contentDescription,
                contentDisposition: resource.attachment.contentDisposition,
                hash: resource.attachment.hash,
                fileName: resource.attachment.fileName,
                creation: resource.attachment.creation
            } : null,
            rating: resource === null || resource === void 0 ? void 0 : resource.rating,
            meta: {
                versionId: (_resource$meta$versio = resource === null || resource === void 0 || (_resource$meta = resource.meta) === null || _resource$meta === void 0 ? void 0 : _resource$meta.versionId) !== null && _resource$meta$versio !== void 0 ? _resource$meta$versio : 0,
                created: (_resource$meta$create = resource === null || resource === void 0 || (_resource$meta2 = resource.meta) === null || _resource$meta2 === void 0 ? void 0 : _resource$meta2.created) !== null && _resource$meta$create !== void 0 ? _resource$meta$create : '',
                lastUpdated: resource === null || resource === void 0 || (_resource$meta3 = resource.meta) === null || _resource$meta3 === void 0 ? void 0 : _resource$meta3.lastUpdated,
                createdBy: resource === null || resource === void 0 || (_resource$meta4 = resource.meta) === null || _resource$meta4 === void 0 ? void 0 : _resource$meta4.createdBy,
                lastUpdatedBy: resource === null || resource === void 0 || (_resource$meta5 = resource.meta) === null || _resource$meta5 === void 0 ? void 0 : _resource$meta5.lastUpdatedBy,
                isDeleted: (_resource$meta$isDele = resource === null || resource === void 0 || (_resource$meta6 = resource.meta) === null || _resource$meta6 === void 0 ? void 0 : _resource$meta6.isDeleted) !== null && _resource$meta$isDele !== void 0 ? _resource$meta$isDele : false,
                deviceId: resource === null || resource === void 0 || (_resource$meta7 = resource.meta) === null || _resource$meta7 === void 0 ? void 0 : _resource$meta7.deviceId,
                clientRequestId: resource === null || resource === void 0 || (_resource$meta8 = resource.meta) === null || _resource$meta8 === void 0 ? void 0 : _resource$meta8.clientRequestId,
                requestLogRef: resource === null || resource === void 0 || (_resource$meta9 = resource.meta) === null || _resource$meta9 === void 0 ? void 0 : _resource$meta9.requestLogRef,
                source: resource === null || resource === void 0 || (_resource$meta0 = resource.meta) === null || _resource$meta0 === void 0 ? void 0 : _resource$meta0.source
            }
        };
    };
    var mergePollingNotifications = function mergePollingNotifications(prev, newNotifications) {
        if (prev.length === 0) {
            return newNotifications;
        }
        var existingIds = new Set(prev.map(function (n) {
            return n.id;
        }));
        var brandNewNotifications = newNotifications.filter(function (n) {
            return !existingIds.has(n.id);
        });
        var updatedExisting = prev.map(function (existing) {
            var updated = newNotifications.find(function (n) {
                return n.id === existing.id;
            });
            if (!updated)
                return existing;
            // Preserve local viewedDateTime if it exists but server data doesn't have it yet
            // This prevents race condition where polling overwrites local read state with stale server data
            if (existing.viewedDateTime && !updated.viewedDateTime) {
                return _objectSpread(_objectSpread({}, updated), {}, {
                    viewedDateTime: existing.viewedDateTime
                });
            }
            return updated;
        });
        if (brandNewNotifications.length > 0) {
            setPlay(true);
            return [].concat(_toConsumableArray(brandNewNotifications), _toConsumableArray(updatedExisting));
        }
        return updatedExisting;
    };
    var handleLoadMoreNotifications = function handleLoadMoreNotifications(prev, newNotifications) {
        var existingIds = new Set(prev.map(function (n) {
            return n.id;
        }));
        var uniqueNew = newNotifications.filter(function (n) {
            return !existingIds.has(n.id);
        });
        var shouldHaveMore = newNotifications.length === LIMIT;
        setHasMore(shouldHaveMore);
        return [].concat(_toConsumableArray(prev), _toConsumableArray(uniqueNew));
    };
    var handleInitialLoad = function handleInitialLoad(newNotifications) {
        var shouldHaveMore = newNotifications.length === LIMIT;
        setNotifications(newNotifications);
        setHasMore(shouldHaveMore);
    };
    var handleNotificationSuccess = function handleNotificationSuccess(data, isMounted) {
        var _data$entry;
        var isLoadMore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isPolling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (!isMounted)
            return;
        var newNotifications = ((_data$entry = data.entry) !== null && _data$entry !== void 0 ? _data$entry : []).map(mapNotificationEntry);
        if (isLoadMore) {
            setNotifications(function (prev) {
                return handleLoadMoreNotifications(prev, newNotifications);
            });
            setIsLoadingMore(false);
            return;
        }
        if (isPolling) {
            setNotifications(function (prev) {
                return mergePollingNotifications(prev, newNotifications);
            });
            setIsLoadingMore(false);
            return;
        }
        handleInitialLoad(newNotifications);
        setIsLoadingMore(false);
    };
    var handleNotificationError = function handleNotificationError(err, isMounted) {
        if (!isMounted)
            return;
        var message = getErrorMessage(err);
        setError(message);
    };
    var shouldLoadMore = function shouldLoadMore(scrollPercentage) {
        return scrollPercentage > 0.8 && hasMore && !isLoadingMore && !error;
    };
    var triggerLoadMore = function triggerLoadMore() {
        var newOffset = offset + LIMIT;
        setOffset(newOffset);
        var fetchFn = globalThis.fetchNotifications;
        if (fetchFn) {
            fetchFn(newOffset, true);
        }
    };
    var handleScroll = function handleScroll(e) {
        var target = e.currentTarget;
        var scrollPercentage = (target.scrollTop + target.clientHeight) / target.scrollHeight;
        // Show/hide scroll-to-top button based on scroll position
        setShowScrollTop(target.scrollTop > 100);
        // Load more when scrolled 80% of the way down
        if (shouldLoadMore(scrollPercentage)) {
            triggerLoadMore();
        }
    };
    // Fetch notifications on mount and poll with backoff on failures
    useEffect(function () {
        var isMounted = true;
        var intervalId;
        var isPollingInFlight = false;
        var consecutivePollingFailures = 0;
        var MAX_CONSECUTIVE_POLLING_FAILURES = 3;
        var scheduleNextPoll = function scheduleNextPoll() {
            if (intervalId)
                clearInterval(intervalId);
            if (!isMounted)
                return;
            if (consecutivePollingFailures >= MAX_CONSECUTIVE_POLLING_FAILURES) {
                return;
            }
            // Backoff: double the interval for each consecutive failure (30s → 60s → 120s)
            var delay = NOTIFICATION_POLL_INTERVAL_MS * Math.pow(2, consecutivePollingFailures);
            intervalId = setInterval(function () {
                fetchNotifications(0, false, true);
            }, delay);
        };
        var fetchNotifications = function fetchNotifications() {
            var currentOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var isLoadMore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var isPolling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (platformHost !== null && platformHost !== void 0 && platformHost.includes('https://')) {
                if (isPolling && isPollingInFlight)
                    return;
                if (isLoadMore) {
                    setIsLoadingMore(true);
                }
                else if (!isPolling) {
                    setError(null);
                }
                if (isPolling)
                    isPollingInFlight = true;
                NotificationAPI.getNotificationBundle(userId, currentOffset, LIMIT, ['pull'], platformHost).then(function (data) {
                    handleNotificationSuccess(data, isMounted, isLoadMore, isPolling);
                    setUnreadCount(data.totalUnread);
                    if (isPolling && consecutivePollingFailures > 0) {
                        consecutivePollingFailures = 0;
                        scheduleNextPoll();
                    }
                })["catch"](function (err) {
                    handleNotificationError(err, isMounted);
                    if (isPolling) {
                        consecutivePollingFailures += 1;
                        scheduleNextPoll();
                    }
                })["finally"](function () {
                    if (isPolling)
                        isPollingInFlight = false;
                });
            }
        };
        globalThis.fetchNotifications = fetchNotifications;
        if (!userId)
            return;
        setOffset(0);
        setHasMore(true);
        fetchNotifications(0, false, false);
        // Start polling to keep badge count updated
        scheduleNextPoll();
        return function () {
            isMounted = false;
            if (intervalId)
                clearInterval(intervalId);
        };
    }, [userId, platformHost]);
    // Filter notifications based on toggle
    var filteredNotifications = useMemo(function () {
        return onlyUnread ? notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (n) {
            return !n.viewedDateTime;
        }) : notifications;
    }, [onlyUnread, notifications]);
    // Group notifications
    var grouped = groupNotifications(filteredNotifications);
    var notificationCount = useMemo(function () {
        return notifications.filter(function (n) {
            return !n.viewedDateTime;
        }).length;
    }, [notifications]);
    var renderErrorState = function renderErrorState() {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                height: 444,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                pt: 6,
                pb: 6
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            color: "error",
            align: "center",
            sx: {
                fontSize: 16,
                fontWeight: 600,
                color: theme.palette.error.main
            }
        }, error));
    };
    var renderEmptyState = function renderEmptyState() {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                height: 444,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                pt: 6,
                pb: 6
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: AlertStateIcon,
            alt: constants.NO_NOTIFICATIONS,
            style: {
                width: 64,
                height: 64
            }
        }), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                mt: 1,
                pt: 1,
                pb: 1,
                pl: 3,
                pr: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            color: "text.secondary",
            align: "center",
            sx: {
                fontSize: 16,
                fontWeight: 600,
                color: theme.palette.text.primary
            }
        }, constants.NO_NOTIFICATIONS)));
    };
    var renderGroupLabel = function renderGroupLabel(group, idx) {
        // Don't render heading for "recent" group (last 7 days)
        if (group === 'recent') {
            return null;
        }
        var isFirstGroup = idx === 0;
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                mt: isFirstGroup ? '8px' : '16px',
                mb: '4px'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption",
            sx: {
                color: theme.palette.text.secondary,
                fontWeight: 600,
                fontSize: 13,
                pl: '12px',
                letterSpacing: 1
            },
            "data-testid": "typography-caption"
        }, groupLabels[group]));
    };
    // Handle rating submission
    var handleRatingClick = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(rating) {
            var user, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setSelectedRating(rating);
                            // Start fading the notification after a brief moment to show filled stars
                            setTimeout(function () {
                                setIsFadingRating(true);
                            }, 100);
                            _context.p = 1;
                            user = getUserFromCookie();
                            _context.n = 2;
                            return NotificationAPI.submitSurveyResponse(rating, user, platformHost);
                        case 2:
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Error submitting rating:', _t);
                        case 4:
                            // After 1.5 seconds of fading, show thank you message
                            setTimeout(function () {
                                setIsFadingRating(false);
                                setRatingSubmitted(true);
                            }, 1600);
                            // After 5 more seconds, dismiss the rating prompt
                            setTimeout(function () {
                                setIsRatingDismissed(true);
                                setRatingSubmitted(false);
                                setSelectedRating(0);
                                setHoveredRating(0);
                            }, 6600);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3]]);
        }));
        return function handleRatingClick(_x) {
            return _ref4.apply(this, arguments);
        };
    }();
    var renderStarButton = function renderStarButton(star) {
        var activeRating = selectedRating > 0 ? selectedRating : hoveredRating;
        var isFilled = star <= activeRating;
        var StarComponent = isFilled ? StarIcon : StarBorderIcon;
        var starColor = isFilled ? '#FFD700' : '#D1D5DB';
        return /*#__PURE__*/ React.createElement(IconButton, {
            key: star,
            onClick: function onClick() {
                return handleRatingClick(star);
            },
            onMouseEnter: function onMouseEnter() {
                return selectedRating === 0 && setHoveredRating(star);
            },
            onMouseLeave: function onMouseLeave() {
                return selectedRating === 0 && setHoveredRating(0);
            },
            sx: {
                p: 0.25,
                cursor: selectedRating > 0 ? 'default' : 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                    transform: selectedRating === 0 ? 'scale(1.1)' : 'none',
                    backgroundColor: 'transparent'
                }
            },
            disabled: selectedRating > 0
        }, /*#__PURE__*/ React.createElement(StarComponent, {
            sx: {
                fontSize: 20,
                color: starColor
            }
        }));
    };
    // Render rating notification
    var renderRatingNotification = function renderRatingNotification() {
        var RATING_STARS = [1, 2, 3, 4, 5];
        // Show thank you message if submitted
        if (ratingSubmitted) {
            return /*#__PURE__*/ React.createElement(Box, {
                key: "rating-notification",
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    background: theme.palette.background.paper,
                    border: "1px solid ".concat(theme.palette.background.paper),
                    borderRadius: 3,
                    borderBottom: 'none',
                    pl: 2,
                    pt: 2.5,
                    pb: 2.5,
                    pr: 2.5,
                    mb: 0.5,
                    position: 'relative'
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    mr: 2
                }
            }, getNotificationIcon(NOTIFICATION_TITLES.FEEDBACK, '#000000')), /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                sx: {
                    fontWeight: 600,
                    fontSize: 16,
                    color: theme.palette.text.primary
                }
            }, constants.notification_rating_thanks));
        }
        return /*#__PURE__*/ React.createElement(Box, {
            key: "rating-notification",
            sx: _objectSpread({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                background: theme.palette.background.paper,
                border: "1px solid ".concat(theme.palette.background.paper),
                borderRadius: 3,
                borderBottom: 'none',
                pl: 2,
                pt: 2,
                pb: 2,
                pr: 3,
                mb: 0.5,
                position: 'relative',
                opacity: isFadingRating ? 0.3 : 1,
                transition: 'opacity 3s ease-out',
                pointerEvents: isFadingRating ? 'none' : 'auto'
            }, !isFadingRating && {
                '&:hover': {
                    borderRadius: '12px',
                    border: "1px solid #F5F5F5",
                    background: '#FFF'
                }
            })
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'flex-start',
                width: '100%'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                mr: 2
            }
        }, getNotificationIcon(NOTIFICATION_TITLES.FEEDBACK, '#000000')), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                flex: 1
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            sx: {
                fontWeight: 600,
                fontSize: 16,
                color: theme.palette.text.primary,
                mb: 1
            }
        }, NOTIFICATION_TITLES.FEEDBACK), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                gap: 0.5,
                alignItems: 'center'
            }
        }, RATING_STARS.map(function (star) {
            return renderStarButton(star);
        })))));
    };
    var renderNotification = function renderNotification(notification) {
        return /*#__PURE__*/ React.createElement(NotificationItem, {
            key: notification.id,
            notification: notification
        });
    };
    // Extract nested ternary operation into independent statement
    var renderNotificationContent = function renderNotificationContent() {
        var showRating = shouldShowSurveyNotification && !isRatingDismissed;
        if (error && notifications.length === 0 && !showRating) {
            return renderErrorState();
        }
        // Check if we have content to show (either notifications or rating notification)
        var hasContent = filteredNotifications.length > 0 || showRating;
        if (!hasContent) {
            return renderEmptyState();
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, showRating && !isSurveyLoading && renderRatingNotification(), Object.entries(grouped).map(function (_ref5, idx) {
            var _ref6 = _slicedToArray(_ref5, 2), group = _ref6[0], notifs = _ref6[1];
            return /*#__PURE__*/ React.createElement(React.Fragment, {
                key: group
            }, notifs.length > 0 && renderGroupLabel(group, idx), notifs.map(function (notification) {
                return renderNotification(notification);
            }));
        }));
    };
    var scrollToTop = function scrollToTop() {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };
    var getUnreadNotificationIds = function getUnreadNotificationIds() {
        return notifications.filter(function (n) {
            var _n$title;
            return !n.viewedDateTime && ((_n$title = n.title) === null || _n$title === void 0 ? void 0 : _n$title.trim().toLowerCase()) !== NOTIFICATION_TITLES.FEEDBACK.toLowerCase();
        }).map(function (n) {
            return n.id;
        });
    };
    var markNotificationsAsReadLocally = function markNotificationsAsReadLocally() {
        var now = new Date().toISOString();
        setNotifications(function (prev) {
            return prev.map(function (n) {
                var _n$title2;
                // Don't mark feedback notifications as read
                if (((_n$title2 = n.title) === null || _n$title2 === void 0 ? void 0 : _n$title2.trim().toLowerCase()) === NOTIFICATION_TITLES.FEEDBACK.toLowerCase()) {
                    return n;
                }
                return n.viewedDateTime ? n : _objectSpread(_objectSpread({}, n), {}, {
                    viewedDateTime: now
                });
            });
        });
        setUnreadCount(function (prev) {
            return prev - notificationCount;
        });
    };
    var handleMarkAllAsRead = /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var messagesIdList, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            if (!(unreadCount === 0)) {
                                _context2.n = 1;
                                break;
                            }
                            return _context2.a(2);
                        case 1:
                            messagesIdList = getUnreadNotificationIds();
                            _context2.p = 2;
                            _context2.n = 3;
                            return NotificationAPI.markNotificationAsRead(messagesIdList, undefined, platformHost);
                        case 3:
                            markNotificationsAsReadLocally();
                            _context2.n = 5;
                            break;
                        case 4:
                            _context2.p = 4;
                            _t2 = _context2.v;
                            console.error('Error marking notifications as read:', _t2);
                            setError(getErrorMessage(_t2));
                        case 5:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[2, 4]]);
        }));
        return function handleMarkAllAsRead() {
            return _ref7.apply(this, arguments);
        };
    }();
    var renderNotificationBadge = function renderNotificationBadge() {
        return /*#__PURE__*/ React.createElement(Badge, {
            badgeContent: unreadCount > 0 ? unreadCount : null,
            color: "error",
            overlap: "circular",
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            },
            sx: getBadgeStyles(theme)
        }, /*#__PURE__*/ React.createElement(NotificationsIcon, {
            sx: {
                color: getBellIconColor(),
                fontSize: 32
            },
            "data-testid": "notifications-icon"
        }));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "show notifications",
        onClick: handleBellClick,
        size: "large",
        sx: {
            p: 0
        },
        "data-testid": "notification-icon-button"
    }, renderNotificationBadge()), /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableRestoreFocus: true,
        "data-testid": "notification-menu",
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
        },
        marginThreshold: 0,
        slotProps: {
            paper: {
                style: {
                    width: 450,
                    maxWidth: 450,
                    height: 575,
                    borderRadius: '16px',
                    background: '#FFF',
                    boxShadow: theme.shadows[8],
                    padding: 0,
                    overflow: 'visible',
                    marginTop: 26,
                    marginLeft: 58
                },
                sx: {
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: -10,
                        // moved up 0.5px to overlap and hide seam
                        left: tipPosition,
                        transform: 'translateX(-50%)',
                        width: 16,
                        // slightly wider to smooth anti-aliasing
                        height: 12,
                        // taller so base overlaps menu top edge
                        background: 'transparent',
                        zIndex: 2,
                        pointerEvents: 'none',
                        // Arrow shape: pronounced rounded tip (dome) with added overlap to prevent bottom hairline
                        WebkitClipPath: 'polygon(46% 0%, 54% 0%, 100% 100%, 0% 100%)',
                        clipPath: 'path("M0 100% L46% 10% Q50% 0% 54% 10% L100% 100% Z")',
                        backgroundColor: theme.palette.background.paper,
                        // Removed boxShadow to eliminate dark hairline; optional subtle shadow could use filter if needed
                        boxShadow: 'none'
                    }
                }
            },
            list: {
                sx: {
                    padding: 0
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            p: 3,
            justifyContent: 'space-between',
            background: theme.palette.background.paper,
            borderTopLeftRadius: 18,
            borderTopRightRadius: 18,
            position: 'sticky',
            top: 0,
            zIndex: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        sx: {
            fontWeight: 600,
            fontSize: 16,
            color: theme.palette.text.primary
        },
        "data-testid": "typography-subtitle1"
    }, constants.NOTIFICATIONS, ' ', unreadCount > 0 ? "(".concat(unreadCount, ")") : ''), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontSize: 12,
            color: theme.palette.text.secondary,
            fontWeight: 600
        },
        "data-testid": "typography-body2"
    }, constants.ONLY_SHOW_UNREAD), /*#__PURE__*/ React.createElement(Switch, {
        checked: onlyUnread,
        onChange: function onChange(e) {
            return setOnlyUnread(e.target.checked);
        },
        size: "small",
        color: "primary",
        sx: {
            ml: 0.5,
            // Set CSS custom properties for dynamic colors
            '--switch-bg-color': "".concat((configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.button_color) || theme.palette.primary.main),
            // Slightly transparent background
            '--switch-border-color': "rgba(255, 255, 255, 0.40)",
            // Much lighter border for contrast
            '--switch-hover-color': "".concat((configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.button_color) || theme.palette.primary.main, "14"),
            // Hover color with low opacity
            '--switch-off-bg-color': '#D9D9D9',
            // Pure light grey background for off-state
            '--switch-off-border-color': 'rgba(255, 255, 255, 0.40)' // More visible grey border
        },
        "data-testid": "unread-only-switch"
    }))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: theme.palette.divider,
            borderBottomWidth: '1px',
            mb: 0
        },
        "data-testid": "divider"
    }), /*#__PURE__*/ React.createElement(Box, {
        "data-testid": "scroll-container",
        ref: scrollContainerRef,
        onScroll: handleScroll,
        sx: {
            height: 452,
            maxHeight: 452,
            overflowY: 'auto',
            background: theme.palette.background["default"],
            px: 0,
            py: 0,
            pt: 1,
            pl: 1,
            pr: 1,
            position: 'relative',
            // Custom scrollbar styles
            '&::-webkit-scrollbar': {
                width: '6px'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: theme.palette.mode === 'light' ? '#E5E7EB' : '#4B5563',
                borderRadius: '3px',
                '&:hover': {
                    background: theme.palette.mode === 'light' ? '#D1D5DB' : '#6B7280'
                }
            },
            // Remove scrollbar arrows (buttons)
            '&::-webkit-scrollbar-button': {
                display: 'none'
            },
            // Firefox scrollbar
            scrollbarWidth: 'thin',
            scrollbarColor: theme.palette.mode === 'light' ? '#E5E7EB transparent' : '#4B5563 transparent'
        }
    }, renderNotificationContent(), isLoadingMore && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            py: 2
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: theme.palette.text.secondary,
            fontSize: 13
        }
    }, constants.loading_more))), showScrollTop && /*#__PURE__*/ React.createElement(Fab, {
        onClick: scrollToTop,
        size: "small",
        "data-testid": "scroll-to-top-button",
        sx: {
            position: 'absolute',
            bottom: 50,
            right: 25,
            backgroundColor: (configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.button_color) || theme.palette.primary.main,
            color: '#FFFFFF',
            width: 40,
            height: 40,
            boxShadow: theme.shadows[6],
            zIndex: 10,
            '&:hover': {
                backgroundColor: (configState === null || configState === void 0 || (_configState$settings6 = configState.settings) === null || _configState$settings6 === void 0 ? void 0 : _configState$settings6.button_color) || theme.palette.primary.dark,
                opacity: 0.95
            }
        },
        "aria-label": "scroll to top"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z",
        fill: "white"
    }))), filteredNotifications.length > 0 && /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: theme.palette.divider,
            borderBottomWidth: '1px',
            mt: 0,
            mb: 0
        },
        "data-testid": "divider"
    }), filteredNotifications.length > 0 ? /*#__PURE__*/ React.createElement(PermissionGate, {
        action: [RBAC_ACTIONS.RBAC_UPDATE_NOTIFICATION]
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            pt: 2.5,
            pl: 3,
            pr: 3,
            pb: 2.5,
            background: theme.palette.background.paper,
            borderBottomLeftRadius: 18,
            borderBottomRightRadius: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            height: '20px',
            cursor: unreadCount === 0 ? 'not-allowed' : 'pointer',
            opacity: unreadCount === 0 ? 0.3 : 1,
            pointerEvents: unreadCount === 0 ? 'none' : 'auto',
            '&:hover': {
                background: unreadCount === 0 ? theme.palette.background.paper : theme.palette.grey[50]
            },
            fontWeight: 700,
            fontSize: 16,
            color: (configState === null || configState === void 0 || (_configState$settings7 = configState.settings) === null || _configState$settings7 === void 0 ? void 0 : _configState$settings7.button_color) || theme.palette.primary.main,
            gap: 0.5
        },
        onClick: handleMarkAllAsRead,
        "data-testid": "clickable-box"
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: 24,
            height: 24,
            display: 'inline-block',
            verticalAlign: 'middle',
            backgroundColor: (configState === null || configState === void 0 || (_configState$settings8 = configState.settings) === null || _configState$settings8 === void 0 ? void 0 : _configState$settings8.button_color) || theme.palette.primary.main,
            mask: "url(".concat(checkdouble, ") no-repeat center / contain"),
            WebkitMask: "url(".concat(checkdouble, ") no-repeat center / contain")
        }
    }), ' ', constants.MARK_ALL_AS_READ)) : /*#__PURE__*/ React.createElement(Box, {
        sx: {
            pt: 2,
            pb: 2,
            pl: 3,
            pr: 3,
            background: theme.palette.background["default"],
            borderBottomLeftRadius: 18,
            borderBottomRightRadius: 18,
            minHeight: 48,
            // match the button height
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
        },
        "data-testid": "empty-footer"
    }))), /*#__PURE__*/ React.createElement(Sound, {
        type: "notification",
        play: play,
        setPlay: setPlay
    }));
};
export default NotificationModal;
